import React from "react";
import "./Modal.css";

interface ExportModalProps {
  isOpen: boolean;
  onClose: () => void;
  onExport: () => void;
  title?: string;
  children?: React.ReactNode;
}

const ExportModal: React.FC<ExportModalProps> = ({
  isOpen,
  onClose,
  onExport,
  title = "Export Data",
  children,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-close" onClick={onClose}>
          <svg
            width={28}
            height={28}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <g id="Menu / Close_SM">
                {" "}
                <path
                  id="Vector"
                  d="M16 16L12 12M12 12L8 8M12 12L16 8M12 12L8 16"
                  stroke="#000000"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>{" "}
              </g>{" "}
            </g>
          </svg>
        </div>

        <h2 className="modal-title">{title}</h2>

        <div className="modal-content">{children}</div>

        <div className="modal-footer">
          <button className="modal-export-button" onClick={onExport}>
            Export
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExportModal;
